import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type UseDebitAuthPutParams = {
  debitAuthId: string
  enabled: boolean
  limit: number
}

type UseDebitAuthDeleteParams = {
  debitAuthId: string
}

export function useDebitAuthPut() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, UseDebitAuthPutParams>({
    mutationFn: async ({ debitAuthId, limit, enabled }) => {
      const response = await fetcher(
        `/DebitAuth/${debitAuthId}`,
        {
          method: "PUT",
          body: JSON.stringify({
            limit,
            enabled,
          }),
        },
        {
          useAccessToken: true,
        }
      )

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["DebitAuth/List"] })
    },
  })
}

export function useDebitAuthDelete() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, UseDebitAuthDeleteParams>({
    mutationFn: async ({ debitAuthId }) => {
      const response = await fetcher(
        `/DebitAuth/${debitAuthId}`,
        {
          method: "DELETE",
        },
        {
          useAccessToken: true,
        }
      )

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["DebitAuth/List"] })
    },
  })
}
